import React from 'react';
import { Box, Typography } from '@mui/material';
import { accessDeniedStyles } from './styles';

export const AccessDenied = () => (
  <Box sx={accessDeniedStyles}>
    <Typography variant="h2">You don't have permission to view this page</Typography>
  </Box>
);
